import { ColorsGrid } from '@boss/ui';

import { useFavorites } from '../../hooks';

const ColorsGridWrapper = (props: React.ComponentProps<typeof ColorsGrid>) => {
  const { favorites, toggleFavorite } = useFavorites();

  return (
    <ColorsGrid
      {...props}
      colors={props.colors}
      favoriteColorIds={favorites.COLORS}
      onFavorite={color => toggleFavorite('COLORS', color.code.toString(), color)}
    />
  );
};

export default ColorsGridWrapper;
